import _ from 'lodash'
import { round } from 'mathjs'

export default {
  methods: {

    displayPriceActiveChange(prevActive, newActive) {
      if(prevActive == newActive) {
        return this.$options.filters.formatBoolean(newActive)
      }
      var output = ''
      output += this.$options.filters.formatBoolean(prevActive)
      output += `&nbsp;<i class="far fa-long-arrow-right price-log-change-arrow"></i>&nbsp;`
      output += `<span class="font-weight-bold">${this.$options.filters.formatBoolean(newActive)}</span>`
      return output
    },
    
    displayPriceChange(prevPrice, newPrice, uomType = null) {
      let newPriceValue = parseFloat(newPrice ? newPrice : 0)
      let prevPriceValue = parseFloat(prevPrice ? prevPrice : 0)
      let change = newPriceValue - prevPriceValue
      let className = change < 0 ? 'financial-loss' : (change > 0 ? 'financial-profit' : '')

      if(change == 0.0) {
        if(isNaN(parseFloat(newPrice)))
          return '-'
        return this.$options.filters.formatPriceWithUOM(newPrice, uomType)
      }

      var changePercent = 0
      if(prevPriceValue != 0)
        changePercent = round((change / prevPriceValue) * 100.0, 2)

      var output = ''
      output += this.$options.filters.formatPriceWithUOM(prevPrice, uomType)
      output += `&nbsp;<i class="far fa-long-arrow-right price-log-change-arrow"></i>&nbsp;`
      output += this.$options.filters.formatPriceWithUOM(newPrice, uomType)
      if(changePercent != 0)
        output += `<a rel="tooltip" data-toggle="tooltip" data-placement="top" title="${changePercent > 0 ? '+' : ''}${changePercent.toFixed(2)}%">`
      output += ` (<span class="font-weight-bold ${className}">${change > 0 ? '+' : ''}` + this.$options.filters.formatPriceWithUOM(change, uomType) + `</span>)`
      if(changePercent != 0)
        output += `</a>`


      return output
    },
    displayValueChange(prevValue, newValue, precision = 2) {
      let newAmountValue = parseFloat(newValue ? newValue : 0)
      let prevAmountValue = parseFloat(prevValue ? prevValue : 0)
      let change = newAmountValue - prevAmountValue
      let className = change < 0 ? 'financial-loss' : (change > 0 ? 'financial-profit' : '')

      if(change == 0.0) {
        if(isNaN(parseFloat(newValue)))
          return '-'
        return this.$options.filters.formatDecimal(newValue, precision)
      }

      var changePercent = 0
      if(prevAmountValue != 0)
        changePercent = round((change / prevAmountValue) * 100.0, precision)

      var output = ''
      output += this.$options.filters.formatDecimal(prevValue, precision)
      output += `&nbsp;<i class="far fa-long-arrow-right price-log-change-arrow"></i>&nbsp;`
      output += this.$options.filters.formatDecimal(newValue, precision)
      if(changePercent != 0)
        output += `<a rel="tooltip" data-toggle="tooltip" data-placement="top" title="${changePercent > 0 ? '+' : ''}${changePercent.toFixed(2)}%">`
      output += ` (<span class="font-weight-bold ${className}">${change > 0 ? '+' : ''}` + this.$options.filters.formatDecimal(change, precision) + `</span>)`
      if(changePercent != 0)
        output += `</a>`

      return output
    },

    supplierPriceChanged(priceChangeRow, headerId, headerKey) {
      var price = priceChangeRow.prices.find(price => price.changed && price[headerKey] == headerId)
      return price != null      
    },
    supplierPriceRemoved(priceChangeRow, headerId, headerKey) {
      var price = priceChangeRow.prices.find(price => price.changed && price[headerKey] == headerId)
      if(price && price.isRemoved)
        return true
      return false
    },

    displaySupplierPriceChange(priceChangeRow, headerId, headerKey, uomType = null) {
      var price = priceChangeRow.prices.find(price => price[headerKey] == headerId)
      if(price == null)
        return ''
      if(!price.changed || price.isRemoved)
        return this.$options.filters.formatPriceWithUOM(price.price, uomType)

      return this.displayPriceChange(price.oldPrice, price.price, uomType)
    },

    // Go through prices & detect changes from current to new sales prices
    // Adds the changed prices into the changeList array
    addPriceChangeList(changeList, options) {
      if(options.newList == null)
        return

      if(!_.isArray(options.key))
        options.key = [options.key]
      
      options.newList.forEach(newPriceItem => {

        var display = ''
        if(options.displayCallback != undefined) {
          display = options.displayCallback(newPriceItem)
        }

        var change = {}
        options.fields.forEach(fieldName => {
          change[fieldName] = false
        })

        // Find old record
        var curRecord = null
        if(options.currentList) {
          curRecord = options.currentList.find(curPriceItem => {
            return options.key.filter(key => curPriceItem[key] == newPriceItem[key]).length == options.key.length
          })
        }
        if(curRecord != null) {
          
          // Check fields
          var diffFields = options.fields.filter(fieldName => {
            if(typeof newPriceItem[fieldName] == 'boolean' || typeof curRecord[fieldName] == 'boolean') {
              return newPriceItem[fieldName] != curRecord[fieldName]
            }

            if(isNaN(parseFloat(newPriceItem[fieldName])) && isNaN(parseFloat(curRecord[fieldName])))
              return false
            return newPriceItem[fieldName] != curRecord[fieldName]
          })
          if(diffFields.length > 0 || options.forceIncludePrice) {
            // Somethings changed. Add the price record

            // Set flags for changed fields
            diffFields.forEach(fieldName => {
              change[fieldName] = true
            })

            changeList.push({
              prev: curRecord,
              new: newPriceItem,
              change: change,
              display: display
            })
          }

        } else {
          // All new record
          options.fields.forEach(fieldName => {
            change[fieldName] = true
          })

          changeList.push({
            prev: null,
            change: change,
            new: newPriceItem,
            display: display
          })
        }
      })
    },


    // Go through prices & detect changes from current to new supplier prices
    // Adds the changed prices into the changeList array
    addSupplierPriceChangeList(changeList, stockChangeList, options) {

      options.newStockPriceList.forEach(newPriceStock => {

        // Check if the alias changed
        var curRecord = options.currentStockPriceList.find(curStockItem => curStockItem.id == newPriceStock.id)
        if(curRecord != null) {
          if(curRecord.alias != newPriceStock.alias) {
            stockChangeList.push({
              id: newPriceStock.id,
              code: newPriceStock.code,
              alias: newPriceStock.alias
            })
          }
        }

        var display = newPriceStock.code
        if(options.displayCallback != undefined) {
          display = options.displayCallback(newPriceStock)
        }

        var changedStockItem = {
          id: newPriceStock.id,
          code: newPriceStock.code,
          display: display,
          prices: []
        }

        // Find current stock record
        curRecord = options.currentStockPriceList.find(curStockItem => curStockItem.id == newPriceStock.id)
        if(curRecord != null) {

          changedStockItem.prices = _.cloneDeep(curRecord.prices)

          changedStockItem.prices.forEach(price => {
            price.changed = false
            price.oldPrice = price.price
            price.isRemoved = false
          })

          // Go through each price record
          options.headerList.forEach(headerItem => {

            var priceFinder = (price) => {
              if(options.key != null) {
                if(price[options.key] != headerItem[options.key])
                  return false
              }
              return true
            }
              
            var curPriceRecord = changedStockItem.prices.find(priceFinder)
            var newPriceRecord = newPriceStock.prices.find(priceFinder)

            if(curPriceRecord != null && newPriceRecord != null) {
            
              // Check price
              if(curPriceRecord.price != newPriceRecord.price) {
                curPriceRecord.changed = true
                curPriceRecord.oldPrice = curPriceRecord.price
                curPriceRecord.price = newPriceRecord.price
              }

            } else if(newPriceRecord && !curPriceRecord) {
              
              // Add pricing in
              var newPrice =_.cloneDeep(newPriceRecord)
              newPrice.changed = true
              newPrice.oldPrice = null

              changedStockItem.prices.push(newPrice)
            } else if(!newPriceRecord && curPriceRecord) {
              // Price removed
              curPriceRecord.changed = true
              curPriceRecord.oldPrice = curPriceRecord.price
              curPriceRecord.price = null
              curPriceRecord.isRemoved = true
            }
          })

        } else {
          // All new stock record
          changedStockItem.prices = _.cloneDeep(newPriceStock.prices)
          changedStockItem.prices.forEach(price => {
            price.oldPrice = null
            price.changed = true
            price.isRemoved = false
          })
        }

        // If any price has changed, add the row into the change list
        if(changedStockItem.prices.filter(price => price.changed).length > 0) {
          changeList.push(changedStockItem)
        }
      })

      // List of records removed
      options.currentStockPriceList.forEach(currentStock => {

        // Stock remove?
        if(options.newStockPriceList.find(newPriceStock => newPriceStock.id == currentStock.id) == null) {

          var display = currentStock.code
          if(options.displayCallback != undefined) {
            display = options.displayCallback(currentStock)
          }

          var removeStockItem = {
            id: currentStock.id,
            code: currentStock.code,
            display: display,
            prices: _.cloneDeep(currentStock.prices)
          }

          removeStockItem.prices.forEach(price => {
            price.changed = true
            price.oldPrice = price.price
            price.price = null
            price.isRemoved = true
          })

          changeList.push(removeStockItem)
        }
      })
    },

  }
}
